import { z } from 'zod'

import type { SelectOptionsType } from '@/components/ui/form/FormSelect.tsx'

import { weekDays } from '../../consts'

export const WeekdayEnum = z.enum(weekDays)

export const nonRepeatOption: SelectOptionsType[number] = {
  label: 'Not recurring',
  value: 'no-repeat',
}
export const repeatWeekly: SelectOptionsType[number] = {
  label: 'On specific weekdays',
  value: 'weekly',
}
export const repeatDaily: SelectOptionsType[number] = {
  label: 'Daily',
  value: 'daily',
}

export const recurringOptions: SelectOptionsType = [
  nonRepeatOption,
  repeatWeekly,
  repeatDaily,
]

export const ShiftFormSchema = z
  .object({
    startedAt: z.date(),
    finishedAt: z.date(),
    memberIds: z
      .array(z.string())
      .min(1, { message: 'At least one team member must be selected' }),
    recurring: z.string(),
    days: z.array(WeekdayEnum).nullish(),
    isRepetitionInfinite: z.string().optional(),
    endDate: z.date().optional(),
    creatorId: z.string().optional(),
    creatorIds: z
      .array(z.string())
      .min(1, { message: 'At least one creator must be selected' })
      .optional(),
  })
  .refine(
    (data) =>
      [nonRepeatOption.value, repeatDaily.value].includes(data.recurring) ||
      (data.recurring === repeatWeekly.value && !!data.days?.length),
    {
      message: 'At least one day should be selected',
      path: ['days'],
    },
  )
  .refine(
    (data) =>
      data.isRepetitionInfinite === 'true' ||
      (data.isRepetitionInfinite === 'false' && data.endDate),
    {
      path: ['endDate'],
      message: 'End date must be defined',
    },
  )
  .refine(
    (data) =>
      !data.finishedAt ||
      !data.startedAt ||
      data.finishedAt.getTime() > data.startedAt.getTime(),
    { path: ['finishedAt'], message: 'End time should be after start time' },
  )
  .refine(
    (data) =>
      !data.endDate ||
      !data.startedAt ||
      data.endDate.getTime() > data.startedAt.getTime() + 60000,
    { path: ['endDate'], message: 'End date should be after start date' },
  )
